<ion-item *ngIf="orderItemTopping.included" [lines]="containsModifiers(orderItemTopping) ? 'none' : null">
    <ion-label>
        {{ orderItemTopping.menuItemTopping.topping.name }}
        <ng-container *ngIf="includeDisplayModifier(orderItemTopping)"
                      class="selection-summary option-modifier">
        </ng-container>
    </ion-label>
    <span slot="end"
          *ngIf="orderItemTopping.computedPrice">{{ orderItemTopping.computedPrice | currency }}</span>
    <ion-buttons slot="end">
        <ion-button color="dark" (click)="remove.emit()">
            <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
        </ion-button>
    </ion-buttons>
</ion-item>
<bb-order-modifier *ngIf="orderItemTopping.included"
                   [(modifiers)]="orderItemTopping.modifiers"
                   [modifiersDefinition]="orderItemTopping.menuItemTopping.topping"
                   [modifiedItem]="orderItemTopping"
                   [sizeXs]="12"
                   [sizeSm]="12"
                   [sizeMd]="12"
                   [sizeLg]="12"
                   [sizeXl]="12"
                   [child]="true"
                   (modifiersChange)="modifiersChange($event)"
                   slot="content">
</bb-order-modifier>
